class FitLoadMore extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-fit-load-more]');
    if (!this.button) return;

    this.button.addEventListener('click', () => {
      this.querySelectorAll('.fit-guide__product.is-hidden').forEach((product) => {
        product.classList.remove('is-hidden');
      });
      const loadMoreWrapper = this.button.closest('.fit-guide__load-more');
      if (loadMoreWrapper) {
        loadMoreWrapper.remove();
      } else {
        this.button.remove();
      }
    });
  }
}

customElements.define('fit-load-more', FitLoadMore);
